import { IUserStatusViewModel } from "interfaces/models/IUserStatusViewModel";
import { Col } from "react-bootstrap";

const EmailTemplate = ({ emailAddress }: IUserStatusViewModel) => (
  <Col lg={4} className="email-address d-none d-lg-block">
    <span data-testid="emailAddress" className="title">{emailAddress}</span>
  </Col>
);

export default EmailTemplate;
